import React, { useState, useEffect, useCallback } from 'react';

const TimeCountDown = ({ dateClass, targetDate, endDate, setSaleTitle, setSaleIsLive }) => {
  const countdownDate = new Date(targetDate).getTime();
  const saleEndDate = new Date(endDate).getTime();
  const [timeLeft, setTimeLeft] = useState({
    days: '00',
    hours: '00',
    minutes: '00',
    seconds: '00',
  });

  const updateTime = useCallback(() => {
    const currentTime = new Date().getTime();
    const distance = countdownDate - currentTime;
    const saleEndDistance = saleEndDate - currentTime;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const endDays = Math.floor(saleEndDistance / (1000 * 60 * 60 * 24));
    const endHours = Math.floor((saleEndDistance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const endMinutes = Math.floor((saleEndDistance % (1000 * 60 * 60)) / (1000 * 60));
    const endSeconds = Math.floor((saleEndDistance % (1000 * 60)) / 1000);

    if (distance > 0) {
      setTimeLeft({
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      });
      setSaleTitle('Sale Starts Soon')
      setSaleIsLive(false);
      return;
    } else if (distance < 0 && saleEndDistance > 0) {
      setTimeLeft({
        days: String(endDays).padStart(2, '0'),
        hours: String(endHours).padStart(2, '0'),
        minutes: String(endMinutes).padStart(2, '0'),
        seconds: String(endSeconds).padStart(2, '0'),
      });
      setSaleIsLive(true);
      return;
    } else {
      setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
      setSaleTitle('Sale Has Ended');
      setSaleIsLive(false);
      return;
    }


  }, [countdownDate, saleEndDate, setSaleIsLive, setSaleTitle]);

  useEffect(() => {
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, [updateTime]);

  return (
    <ul className={`countdown_timer_block unordered_list justify-content-center ${dateClass}`}>
      {['Days', 'Hours', 'Min', 'Sec'].map((label, index) => {
        const timeValues = [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds];
        return (
          <li className="time-section" key={label}>
            <span className="time">{timeValues[index]}</span>
            <small className="time-text">{label}</small>
          </li>
        );
      })}
    </ul>
  );
};

export default TimeCountDown;
